// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_40-7";
export var adjustableWidthBorderHeld = "_40-8";
export var arrow = "_40-3";
export var arrowButton = "_40-4";
export var headerCell = "_40-0";
export var help = "_40-2";
export var icon = "_40-1";
export var iconWrapper = "_40-6";
export var noBorder = "_40-b";
export var nonAdjustableWidthBorder = "_40-9";
export var nonAdjustableWidthBorderHeld = "_40-a";
export var textButton = "_40-5";